import { GridColDef } from "@mui/x-data-grid";
import { Box, Chip } from "@mui/material";
import CustomDataGrid from "../../../components/ui/customDataGrid/customDataGrid.component";
import { useTranslation } from "react-i18next";
import { Build } from "@mui/icons-material";
import { JOB_SERVICES_ENDPOINT } from "../../../consts";
import { useNavigate } from "react-router-dom";
import { useHasPermission } from "../../../contexts/auth";
import { getContrastColor } from "../../../utils";

export default function JobServicesCatalogList() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const canViewJobServices = useHasPermission("service.view_jobservice");

  const columns: GridColDef[] = [
    {
      field: "title",
      headerName: t("Title"),
      flex: 1,
      minWidth: 160,
      renderCell: (params) => {
        const title = params.row.title || "—";
        const color = params.row.color as string | null | undefined;
        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
            <Chip
              label={title}
              size="small"
              sx={
                color
                  ? {
                      bgcolor: color,
                      color: getContrastColor(color),
                      "& .MuiChip-label": { color: getContrastColor(color) },
                    }
                  : {
                      bgcolor: "rgba(128, 128, 128, 0.25)",
                      color: "text.secondary",
                    }
              }
            />
          </Box>
        );
      },
    },
    {
      field: "description",
      headerName: t("Description"),
      valueGetter: (value, row) => row.description || "—",
    },
  ];

  const handleRowClick = (id: string) => {
    navigate(`/service/services-catalog/${id}`);
  };

  if (!canViewJobServices) {
    return null;
  }

  return (
    <CustomDataGrid
      icon={<Build />}
      title={t("Services Catalog")}
      url={JOB_SERVICES_ENDPOINT}
      gridSettingsKey="JOB_SERVICES_CATALOG"
      columns={columns}
      refreshEventName="jobServiceCatalogAdded"
      onRowClick={handleRowClick}
    />
  );
}
